export default __webpack_public_path__ + "static/media/616.e26ed66a.svg";